import { withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "hotels-search-card__image-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "hotels-search-card__status" }, "Срочный заказ", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("img", {
      title: "Далее",
      src: _ctx.urlImg,
      alt: "Изображение отеля",
      style: {"cursor":"pointer"},
      class: "hotels-search-card__image",
      onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => (_ctx.nextImg(...args)), ["prevent"]))
    }, null, 8, ["src"]),
    _hoisted_2
  ]))
}